import type { Fleet } from '../../../../../types'
import { createColumnHelper } from '@tanstack/react-table'
import { formatNumber } from '../../utils/formatNumber'
import { NavLink } from 'react-router-dom'
import { ReportColumnHeader } from '../ReportColumnHeader'

const settings = {
  digits: {
    min: 0,
    max: 0,
  },
  prefix: 'kr ',
}

export default function fleetReportTableData() {
  const columnHelper = createColumnHelper<Fleet>()
  return [
    columnHelper.accessor('regNo', {
      id: 'regNo',
      header: () => <ReportColumnHeader title="Regnr" />,
      enableSorting: false,
      cell: ({ row, getValue }) => (
        <NavLink to={`/reports/fleet/account/${row.original.accountID}`} className="text-blue-600 hover:underline">
          {getValue()}
        </NavLink>
      ),
    }),
    columnHelper.accessor('driverName', {
      id: 'driverName',
      header: () => <ReportColumnHeader title="Sjåfør" />,
      cell: (row) => row.getValue() || '',
      enableSorting: false,
    }),
    columnHelper.accessor('HK', {
      id: 'hk',
      meta: {
        alignmentType: 'right',
      },
      header: () => <ReportColumnHeader title="Status" />,
      cell: ({ row }) => {
        const { accountStatus, termsNow } = row.original
        if (accountStatus === 'AVVIKLET' || accountStatus === 'ADM') return 'ADM'

        return termsNow || ''
      },
      enableSorting: false,
    }),
    columnHelper.accessor('totalTerms', {
      id: 'totalTerms',
      meta: {
        alignmentType: 'right',
      },
      header: () => <ReportColumnHeader title="Leieperiode" />,
      cell: (row) => row.getValue() || '',
      enableSorting: false,
    }),
    columnHelper.accessor('totalKm', {
      id: 'totalKm',
      meta: {
        alignmentType: 'right',
      },
      header: () => <ReportColumnHeader title="KM PT" />,
      cell: (row) => formatNumber(row.getValue()),
      enableSorting: false,
    }),
    columnHelper.accessor('budgetKm', {
      id: 'budgetKm',
      meta: {
        alignmentType: 'right',
      },
      header: () => <ReportColumnHeader title="KM simulert" />,
      cell: (row) => formatNumber(row.getValue()),
      enableSorting: false,
    }),
    columnHelper.accessor('maxKm', {
      id: 'maxKm',
      meta: {
        alignmentType: 'right',
      },
      header: () => <ReportColumnHeader title="Maks km" />,
      cell: (row) => formatNumber(row.getValue()),
      enableSorting: false,
    }),
    columnHelper.accessor('fixedYear', {
      id: 'fixedYear',
      meta: {
        alignmentType: 'right',
        mobileFooterLabel: 'Faste kostnader hittil',
      },
      header: () => <ReportColumnHeader title="Faste kostnader hittil" />,
      cell: (row) => formatNumber(row.getValue(), settings),
      footer: ({ table }) => {
        const total = table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => sum + (Number(row.getValue('fixedYear')) || 0), 0)
        return formatNumber(total, settings)
      },
      enableSorting: false,
    }),
    columnHelper.accessor('fixedContract', {
      id: 'fixedContract',
      meta: {
        alignmentType: 'right',
        mobileFooterLabel: 'Faste kostnader',
      },
      header: () => <ReportColumnHeader title="Faste kostnader" />,
      cell: (row) => formatNumber(row.getValue(), settings),
      footer: ({ table }) => {
        const total = table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => sum + (Number(row.getValue('fixedContract')) || 0), 0)
        return formatNumber(total, settings)
      },
      enableSorting: false,
    }),
    columnHelper.accessor('nonFixedYear', {
      id: 'nonFixedYear',
      meta: {
        alignmentType: 'right',
        mobileFooterLabel: 'Variable kostnader hittil',
      },
      header: () => <ReportColumnHeader title="Variable kostnader hittil" />,
      cell: (row) => formatNumber(row.getValue(), settings),
      footer: ({ table }) => {
        const total = table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => sum + (Number(row.getValue('nonFixedYear')) || 0), 0)
        return formatNumber(total, settings)
      },
      enableSorting: false,
    }),
    columnHelper.accessor('nonFixedContract', {
      id: 'nonFixedContract',
      meta: {
        alignmentType: 'right',
        mobileFooterLabel: 'Variable kostnader',
      },
      header: () => <ReportColumnHeader title="Variable kostnader" />,
      cell: (row) => formatNumber(row.getValue(), settings),
      footer: ({ table }) => {
        const total = table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => sum + (Number(row.getValue('nonFixedContract')) || 0), 0)
        return formatNumber(total, settings)
      },
      enableSorting: false,
    }),
    columnHelper.accessor('totalYear', {
      id: 'totalYear',
      meta: {
        alignmentType: 'right',
        mobileFooterLabel: 'Totale kostnader hittil',
      },
      header: () => <ReportColumnHeader title="Totale kostnader hittil" />,
      cell: (row) => formatNumber(row.getValue(), settings),
      footer: ({ table }) => {
        const total = table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => sum + (Number(row.getValue('totalYear')) || 0), 0)
        return formatNumber(total, settings)
      },
      enableSorting: false,
    }),
    columnHelper.accessor('totalContract', {
      id: 'totalContract',
      meta: {
        alignmentType: 'right',
        mobileFooterLabel: 'Totale kostnader',
      },
      header: () => <ReportColumnHeader title="Totale kostnader" />,
      cell: (row) => formatNumber(row.getValue(), settings),
      footer: ({ table }) => {
        const total = table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => sum + (Number(row.getValue('totalContract')) || 0), 0)
        return formatNumber(total, settings)
      },
      enableSorting: false,
    }),
  ]
}
